import jwtDefaultConfig from './jwtDefaultConfig';
import { camelizeKeys, decamelize, decamelizeKeys } from 'humps';
import { encrypt } from '@/libs/crypto-js';
import Swal from 'sweetalert2';
import i18n from '@/libs/i18n';

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        // If token is present add it to request's Authorization Header
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = encrypt(this.jwtConfig.authorizationKey)

        // If token is present add it to request's Authorization Header
        if (config.params) {
          config.params = decamelizeKeys(config.params);
          if (config.params.order) {
            config.params.order = decamelize(config.params.order);
          }
        }
        if (config.data) {
          config.data = decamelizeKeys(config.data);
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      // response => response,
      response => {
        if (response?.data) {
          response.data = camelizeKeys(response.data);
        }
        return Promise.resolve(response);
      },
      error => {
        const message = error.response?.data?.message;
        if (message) {
          Swal.fire({
            icon: 'info',
            title: i18n.tc(`${message}`),
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            confirmButtonText: i18n.tc('button.close'),
            buttonsStyling: false,
          });
        }

        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.baseUrl + this.jwtConfig.loginEndpoint, ...args);
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.baseUrl + this.jwtConfig.refreshTokenEndpoint, {}, {
      headers: {
        'Re-Authentication': encrypt(this.getRefreshToken()),
      }
    })
  }
}
